//@flow
import * as React from 'react';
import classnames from 'classnames';
import { themr, type ThemeType } from 'react-css-themr';
import { compose } from 'recompose';
import { translate, type TFunction } from 'react-i18next';

import { SelectTypes, CreatableSelect } from 'common/components/core/select';
import enhancedFieldFactory from 'common/components/core/form/EnhancedFieldFactory';

import baseTheme from './EditableChipsList.scss';

const EnhancedSelect = enhancedFieldFactory({
    FieldComponent: CreatableSelect,
    attachPopover: true
});

type Props = {
    theme: ThemeType,
    className: string,
    value: Array<string>,
    options: Array<string>,
    t: TFunction,
    formatCreateLabel: string => string,
    updateValue: (Array<string>) => void,
    creatable: boolean,
    portal: boolean,
    getSelectMenuListRef: (React.ElementRef<any>) => void,
    getSelectMenuRef: (React.ElementRef<any>) => void,
    noOptionsMessage: () => string,
    placeholder: ?string,
    getOptionMeta: () => string,
    doubleLine: boolean,
    hideDropdownIndicator: boolean,
    getOptionLabel: () => string,
    error: ?string
};

class EditableChipsList extends React.Component<Props> {
    static defaultProps = { creatable: true };
    formatCreateLabel = label => {
        const { t, formatCreateLabel } = this.props;
        return formatCreateLabel
            ? formatCreateLabel(label)
            : t('createTag', { label });
    };

    handleChange = selectedOptions => {
        const { updateValue } = this.props;
        const selectedValues = [];
        selectedOptions.forEach(selectedOption => {
            const value = selectedOption.value.trim();
            if (value) {
                selectedValues.push(value);
            }
        });
        updateValue(selectedValues);
    };

    render() {
        const {
            theme,
            className,
            value,
            options,
            error,
            t,
            creatable,
            portal,
            getSelectMenuListRef,
            getSelectMenuRef,
            noOptionsMessage,
            placeholder = t('selectTags'),
            getOptionMeta,
            doubleLine,
            hideDropdownIndicator,
            getOptionLabel
        } = this.props;
        return (
            <div
                className={classnames(theme.editableTagsWrap, {
                    [className]: className
                })}
            >
                <EnhancedSelect
                    getOptionMeta={getOptionMeta}
                    noOptionsMessage={noOptionsMessage}
                    getSelectMenuListRef={getSelectMenuListRef}
                    getSelectMenuRef={getSelectMenuRef}
                    isMulti
                    autoFocus
                    creatable={creatable}
                    disableAnimation
                    openMenuOnFocus
                    isSearchable
                    closeMenuOnSelect={false}
                    isClearable={false}
                    formatCreateLabel={this.formatCreateLabel}
                    selectType={SelectTypes.Outline}
                    error={error}
                    hasError={!!error}
                    place="right"
                    options={options}
                    value={value}
                    onChange={this.handleChange}
                    theme={theme}
                    className={classnames(theme.tagsSelectWrap, {
                        [theme.error]: !!error
                    })}
                    placeholder={placeholder}
                    multiAutoHeight
                    hideDropdownIndicator={hideDropdownIndicator}
                    portal={portal}
                    doubleLine={doubleLine}
                    getOptionLabel={getOptionLabel}
                />
            </div>
        );
    }
}

export default compose(
    themr('EditableChipsList', baseTheme),
    translate('planner')
)(EditableChipsList);
